import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageLoader } from '@dezza/ui';
import { RedirectIfAuthed } from '../../lib/auth';

const LoginPage = lazy(() => import('./LoginPage'));
const SignupPage = lazy(() => import('./SignupPage'));
const Recovery = {
  Forgot: lazy(() => import('./RecoveryPages').then((m) => ({ default: m.ForgotPasswordPage }))),
  Reset: lazy(() => import('./RecoveryPages').then((m) => ({ default: m.ResetPasswordPage }))),
  Verify: lazy(() => import('./RecoveryPages').then((m) => ({ default: m.VerifyEmailPage }))),
  Invite: lazy(() => import('./RecoveryPages').then((m) => ({ default: m.AcceptInvitePage }))),
  Impersonate: lazy(() => import('./RecoveryPages').then((m) => ({ default: m.ImpersonatePage }))),
};

const S = ({ children }: { children: ReactNode }) => <Suspense fallback={<PageLoader />}>{children}</Suspense>;

export const publicRoutes: RouteObject[] = [
  { path: 'entrar', element: <RedirectIfAuthed><S><LoginPage /></S></RedirectIfAuthed> },
  { path: 'cadastro', element: <RedirectIfAuthed><S><SignupPage /></S></RedirectIfAuthed> },
  { path: 'recuperar-senha', element: <S><Recovery.Forgot /></S> },
  { path: 'redefinir-senha', element: <S><Recovery.Reset /></S> },
  { path: 'verificar-email', element: <S><Recovery.Verify /></S> },
  { path: 'convite/:token', element: <S><Recovery.Invite /></S> },
  { path: 'suporte/entrar', element: <S><Recovery.Impersonate /></S> },
];
